module.exports = __webpack_public_path__ + "img/homebg_7.9f59fee7.png";